define('models/book-state',["exports", "backbone", "common"], function (_exports, _backbone, _common) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = _backbone.Model.extend({
    initialize() {
      this.on('change:date$start change:date$end change:date$delay', () => {
        if (!this.attributes.date$delay) {
          var date = null;
          if (this.attributes.date$start) {
            date = {
              start: this.attributes.date$start
            };
            if (this.attributes.date$end) {
              date.end = this.attributes.date$end;
            }
          }
          this.set('date', date);
        }
      });
    },
    getQuery() {
      var currency = this.get('currency');
      var date = this.get('date');
      var guests = this.get('guests');
      var params = new URLSearchParams();
      if (currency) {
        params.set('currency', currency);
      }
      if (date) {
        params.set('date', (0, _common.stringifyDateRange)(date));
      } else {
        params.set('sort', 'best');
      }
      if (guests) {
        params.set('guests', guests);
      }
      return params;
    },
    backFilter() {
      var date = this.attributes.date;
      this.set({
        date$start: date ? date.start : null,
        date$end: date ? date.end : null
      });
    },
    parseQuery() {
      var query = new URLSearchParams(location.search);
      this.set((0, _common.parseBookParams)(query), {
        initial: true
      });
    },
    errorOrWarn() {
      return this.get('error') || this.get('warning') || '';
    }
  });
});//# sourceMappingURL=book-state.js.map
;
